"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants = require("../utils/constants");

var _map = require("./map");

var _map2 = _interopRequireDefault(_map);

var _mapboxGl = require("mapbox-gl");

var _mapboxGl2 = _interopRequireDefault(_mapboxGl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      


/**
 * Map using the mapbox backend
 *
 * @param {string} apiKey The api key used by the map
 * @param {string} containerId The container id where the map will be drawn
 * @param {string} styleId The style id that will be used to draw the map
 */
var MapboxMap = function (_Map) {
	_inherits(MapboxMap, _Map);

	function MapboxMap(apiKey, options) {
		_classCallCheck(this, MapboxMap);

		var defaultParameters = {
			container: "",
			style: "https://tilemaps.icgc.cat/tileserver/styles/water.json",
			center: [1.60859, 41.7554],
			maxZoom: 13,
			zoom: 6
		};

		var _this = _possibleConstructorReturn(this, (MapboxMap.__proto__ || Object.getPrototypeOf(MapboxMap)).call(this, Object.assign(defaultParameters, options)));

		_this.apiKey = apiKey || "";
		_this.layerIds = [];
		_this.sourceIds = [];
		return _this;
	}
	/**
  * Creates the map. Do not call directly
  *
  * @param {function} resolve The function to call when the map creation succeeds
  * @param {function} reject The function to call when the map creation fails
  *
  * @see Map::create
  */


	_createClass(MapboxMap, [{
		key: "mapCreate",
		value: function mapCreate(resolve, reject) {
			var _this2 = this;

			_mapboxGl2.default.accessToken = this.apiKey;
			this.map = new _mapboxGl2.default.Map(this.options);
			this.isInitialized = true;
			this.map.on("load", function () {
				_get(MapboxMap.prototype.__proto__ || Object.getPrototypeOf(MapboxMap.prototype), "mapHasLoaded", _this2).call(_this2);

				// this.map.addSource("terr_zen", {
				// 	type: "raster-dem",
				// 	tiles: [INIT_URL_TERRAIN],
				// 	tileSize: 256,
				// 	encoding: "terrarium",
				// 	maxzoom: 16
				//   });	  
				//   this.map.setTerrain({
				// 	  source: "terr_zen",
				// 	  exaggeration: 1.5,
				// 	}); 

				resolve();
			});
		}
		/**
   * Removes the map from the element. Do not call directly
   *
   * @see Map::remove
   */

	}, {
		key: "mapRemove",
		value: function mapRemove() {
			this.map.remove();
		}
		/**
   * Adds data to draw to the map. Do not call directly
   *
   * @param {MapData} data
   * @see Map::addData
   */

	}, {
		key: "addTerrain",
		value: function addTerrain() {}
	}, {
		key: "addMapData",
		value: function addMapData(data) {
			var _this3 = this;

			data.sources.forEach(function (source) {
				_this3.map.addSource(source.name, source.data);
				_this3.sourceIds.push(source.name);
			});
			data.layers.forEach(function (layer) {
				_this3.map.addLayer(layer);
				_this3.layerIds.push(layer.id);
			});
		}
		/**
   * Removes all the data from the map. Implementation specific
   *
   */

	}, {
		key: "removeMapData",
		value: function removeMapData() {
			var _this4 = this;

			this.layerIds.forEach(function (layer) {
				_this4.map.removeLayer(layer);
			});
			this.layerIds = [];
			this.sourceIds.forEach(function (source) {
				_this4.map.removeSource(source);
			});
			this.sourceIds = [];
		}
		/**
   * Return the style map.
   *
   * @see Map::getStyle
   */

	}, {
		key: "getStyle",
		value: function getStyle() {
			return this.map.getStyle();
		}
		/**
   * Return mapStyle.
   *
   * @param {layerid} layerid
   * @param {property} property
   * @see Map::getPaintProperty
   */

	}, {
		key: "getPaintProperty",
		value: function getPaintProperty(layerid, property) {
			return this.map.getPaintProperty(layerid, property);
		}
		/**
   * Sets the data to draw. Do not call directly
   *
   * @param {baseLayr} url
   * @see Map::setMapBaseLayer
   */

	}, {
		key: "setMapBaseLayer",
		value: function setMapBaseLayer(baseLayerURL) {
			var _this5 = this;

			return new Promise(function (resolve, reject) {
				_this5.map.setStyle(baseLayerURL);
				_this5.map.on("styledata", function (data) {
					_this5.layerIds = [];
					_this5.sourceIds = [];
					if (data.dataType === "style") {

						// if (!this.map.getSource("terr_zen")) {	

						// 		this.map.addSource("terr_zen", {
						// 			type: "raster-dem",
						// 			tiles: [INIT_URL_TERRAIN],
						// 			tileSize: 256,
						// 			encoding: "terrarium",
						// 			maxzoom: 16
						// 		  });	
						// 		  this.map.setTerrain({
						// 			source: "terr_zen",
						// 			exaggeration: 1.5,
						// 		  });
						// }
						resolve();
					}
				});
			});
		}
		/**
   * Fit a map to a bounding box
   *
   * @param {bbox} Array "bbox":"1.079053,41.290767,1.104497,41.308387"
   */

	}, {
		key: "fitBBOX",
		value: function fitBBOX(bbox) {
			var pitch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			var lngLatBounds = [[bbox[0], bbox[1]], [bbox[2], bbox[3]]];
			this.map.fitBounds(lngLatBounds, { pitch: pitch });
		}
	}, {
		key: "fitBounds",
		value: function fitBounds(bounds) {
			this.map.fitBounds(bounds);
		}
		/* "initview": {
  		"lat": INIT_LAT,
  		"lon": INIT_LONG,
  		"zoom": INIT_ZOOM,
  		"pitch": INIT_PITCH,
  		"bearing": INIT_BEARING
  	} */

	}, {
		key: "getZoom",
		value: function getZoom() {
			return this.map.getZoom();
		}
	}, {
		key: "setZoom",
		value: function setZoom(newZoom) {
			this.map.setZoom(newZoom);
		}
	}, {
		key: "setMaxZoom",
		value: function setMaxZoom(newZoom) {
			this.map.setMaxZoom(newZoom);
		}
	}, {
		key: "getPitch",
		value: function getPitch() {
			return this.map.getPitch();
		}
	}, {
		key: "setPitch",
		value: function setPitch(newPitch) {
			return this.map.setPitch(newPitch);
		}
	}, {
		key: "getBearing",
		value: function getBearing() {
			return this.map.getBearing();
		}
	}, {
		key: "setBearing",
		value: function setBearing(newBearing) {
			this.map.setBearing(newBearing);
		}
	}, {
		key: "getBounds",
		value: function getBounds() {
			return this.map.getBounds();
		}
	}, {
		key: "getCenter",
		value: function getCenter() {
			return this.map.getCenter();
		}
	}, {
		key: "setCenter",
		value: function setCenter(lng, lat) {
			this.map.setCenter([lng, lat]);
		}
	}, {
		key: "easeTo",
		value: function easeTo(options) {
			this.map.easeTo(options);
		}
	}, {
		key: "getLayer",
		value: function getLayer(id) {
			return this.map.getLayer(id);
		}
	}, {
		key: "setCursorPointer",
		value: function setCursorPointer(pointer) {
			this.map.getCanvas().style.cursor = pointer;
		}
	}, {
		key: "removeLayer",
		value: function removeLayer(id) {
			if (this.map.getLayer(id)) {
				this.map.removeLayer(id);
			}
		}
	}, {
		key: "removeSource",
		value: function removeSource(id) {
			if (this.map.getSource(id)) {
				this.map.removeSource(id);
			}
		}
	}, {
		key: "addSource",
		value: function addSource(id, source) {
			this.map.addSource(id, source);
		}
	}, {
		key: "addLayer",
		value: function addLayer(layer, before) {
			this.map.addLayer(layer, before);
		}
	}, {
		key: "setPaintProperty",
		value: function setPaintProperty(layer, property, data) {
			if (this.map.getPaintProperty(layer, property)) this.map.setPaintProperty(layer, property, data);
		}
	}, {
		key: "setLayoutProperty",
		value: function setLayoutProperty(layer, property, data) {
			if (this.map.getLayoutProperty(layer, property)) {
				this.map.setLayoutProperty(layer, property, data);
			} else {
				this.map.setLayoutProperty(layer, property, data);
			}
		}
		/**
   * SetFilters
   *
   *
   */

	}, {
		key: "setFilter",
		value: function setFilter(layer, filter) {
			this.map.setFilter(layer, filter);
		}
		/**
   * return filter getFilter
   *
   *
   */

	}, {
		key: "getFilter",
		value: function getFilter(layer) {
			return this.map.getFilter(layer);
		}
	}, {
		key: "updateLayer",
		value: function updateLayer(layer) {
			// console.info("layer", layer);
			if (this.map.getLayer(layer.id)) {
				this.map.removeLayer(layer.id);
				this.map.addLayer(layer);
			} else {
				this.map.addLayer(layer);
			}
			//}
		}
	}, {
		key: "resetView",
		value: function resetView(_ref) {
			var zoom = _ref.zoom,
			    pitch = _ref.pitch,
			    lat = _ref.lat,
			    lon = _ref.lon,
			    bearing = _ref.bearing;

			this.setZoom(zoom);
			this.setPitch(pitch);
			this.setCenter(lon, lat);
			this.setBearing(bearing);
		}
		/**
   * Sets the API key used by the map
   *
   * @param {string} apiKey
   */

	}, {
		key: "setAPIKey",
		value: function setAPIKey(apiKey) {
			this.apiKey = apiKey;
		}
		/**
   * Subscribe to a map event that happens on a layer
   *
   * @param {string} eventName The event name
   * @param {string} layerName The layer name
   * @param {Function} callback The callback to run when the event arrives
   */

	}, {
		key: "subscribe",
		value: function subscribe(eventName, layerName, callback) {
			if (layerName.trim() !== "") this.map.on(eventName, layerName, function (e) {
				return callback(e, layerName);
			});else this.map.on(eventName, function (e) {
				return callback(e);
			});
		}
	}, {
		key: "addControlMap",
		value: function addControlMap(controlName, controlOptions) {
			var defaultOptions = {};
			if (controlName == "attribution") {
				defaultOptions = controlOptions || { compact: true };
				this.map.addControl(new _mapboxGl2.default.AttributionControl(defaultOptions));
			} else if (controlName == "popup") {
				defaultOptions = controlOptions || { closeButton: false };
				var popup = new _mapboxGl2.default.Popup(defaultOptions);
				return popup;
			} else if (controlName == "zoom") {
				defaultOptions = controlOptions || { zoomIn: true, zoomOut: true, compass: false };
				this.map.addControl(new _mapboxGl2.default.NavigationControl(defaultOptions));
			} else {
				this.map.addControl(controlName, controlOptions);
			}
		}
		/**
   * Queries the rendered features in a point or a bbox
   *
   * @param {(PointLike | Array<PointLike>)?} place
   * @param {string} layer
   */

	}, {
		key: "queryRenderedFeatures",
		value: function queryRenderedFeatures(place, layer) {
			return this.map.queryRenderedFeatures(place, { layers: [layer] });
		}
		/**
   * Changes the cursor type
   *
   * @param {string} name
   */

	}, {
		key: "setCursor",
		value: function setCursor(name) {
			this.map.getCanvas().style.cursor = name;
		}
	}]);

	return MapboxMap;
}(_map2.default);

module.exports = MapboxMap;
